
import Component from "vue-class-component"
import Page from "@/report/pages/Page.vue"
import MetricSquare from "@/report/components/MetricSquare.vue"
import AbstractPage from "@/report/pages/AbstractPage.vue"

@Component({
  name: "MembershipPage",
  components: {
    MetricSquare,
    Page,
  },
})
export default class MembershipPage extends AbstractPage {}
